import React, { Component } from 'react';
import { connect } from 'react-redux';
import { message, Popconfirm, Table } from 'antd';
import moment from 'moment';
import { queryCancelRelate, queryRelateNon } from '@api/incubator/finance';
import util from '@util/index';
import { setBackInfo } from '@store/modules/back_info';

class TableNotRelate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      statistics: {},
      data: {
        list: [],
        pagination: {},
      },
    };
  }

  componentDidMount() {
    const { backInfo } = this.props;
    if (backInfo.path === this.props.location.pathname) {
      this.current = backInfo.current;
    }
    this.condition = this.props.condition;
    this.getData();
  }

  componentWillReceiveProps(nextProps) {
    const { backInfo } = this.props;
    if (backInfo.path === this.props.location.pathname) {
      this.current = backInfo.current;
    }
    if (this.props.condition !== nextProps.condition) {
      this.condition = nextProps.condition;
      this.current = 1;
    }
    this.getData();
  }

  componentWillUnmount() {
    const params = {
      path: this.props.location.pathname,
      condition: this.condition,
      current: this.current,
      tabKey: this.props.tabKey,
    };
    this.props.dispatch(setBackInfo(params));
  }

  // 恢复关联
  coverRelevance = incomeUuid => {
    queryCancelRelate({
      incomeUuid,
    }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.getData();
      } else {
        message.error(res.message);
      }
    });
  };

  getData = () => {
    queryRelateNon({
      incubatorUuid: this.props.params.uuid,
      start: this.current || 1,
      ...this.condition,
    }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          data: {
            list: res.data.data,
            pagination: {
              current: this.current,
              total: res.totalSize,
              pageSize: 15,
            },
          },
          statistics: res.data.statistics,
        });
      } else {
        message.error(res.message);
      }
    });
  };

  handleTableChange = pagination => {
    this.current = pagination.current;
    this.getData();
  };

  columns = () => {
    const { accountInfo, paymentTypes } = this.props;
    return [
      {
        title: '日期',
        dataIndex: 'date',
        width: 100,
        render: (text, record, index) => {
          return <span>{text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}</span>;
        },
      },
      {
        title: '对方户名',
        dataIndex: 'accountName',
        width: 200,
      },
      {
        title: '金额',
        dataIndex: 'money',
        width: 80,
        render: (text, record) => <span>{util.numberFormat(record.money || 0)}</span>,
      },
      {
        title: '类型',
        dataIndex: 'target',
        width: 60,
        render: (text, record) => <span>{text === 0 ? '支出' : '收入'}</span>,
      },
      {
        title: '收支类型',
        dataIndex: 'type',
        key: 'type',
        width: 150,
        render: (text, record) => {
          let typeName = '';
          if (paymentTypes.length > 0) {
            paymentTypes.forEach((item, index) => {
              if (text === item.value) {
                typeName = item.key;
                return typeName;
              }
            });
          }
          return <span>{typeName}</span>;
        },
      },
      {
        title: '摘要',
        dataIndex: 'remark',
        width: 150,
      },
      {
        title: '操作',
        dataIndex: 'done',
        width: 100,
        render: (text, record) =>
          accountInfo.isHatcherMng || accountInfo.isIncubatorMng || accountInfo.isFinancialM ? (
            <Popconfirm
              title="确认恢复关联吗？"
              onConfirm={() => {
                this.coverRelevance(record.uuid);
              }}
            >
              <a>恢复关联</a>
            </Popconfirm>
          ) : (
            <span>恢复关联</span>
          ),
      },
    ];
  };

  render() {
    const {
      data: { list, pagination },
      statistics,
    } = this.state;
    return (
      <div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
          }}
        >
          <div style={{ textAlign: 'left', width: '200px' }}>
            <span style={{ paddingRight: '8px' }}>收入</span>
            <span>总金额：{util.numberFormat(statistics.incomeSum || 0)}元</span>
          </div>
        </div>
        <div
          style={{
            marginBottom: '16px',
            display: 'flex',
            justifyContent: 'flex-end',
          }}
        >
          <div style={{ textAlign: 'left', width: '200px' }}>
            <span style={{ paddingRight: '8px' }}>支出</span>
            <span>总金额：{util.numberFormat(statistics.expenditureSum || 0)}元</span>
          </div>
        </div>
        <Table
          rowKey="uuid"
          rowSelection={{}}
          columns={this.columns()}
          dataSource={list}
          pagination={pagination}
          onChange={this.handleTableChange}
        />
      </div>
    );
  }
}
export default connect(state => ({
  accountInfo: state.account_info,
  backInfo: state.back_info,
}))(TableNotRelate);



// WEBPACK FOOTER //
// ./src/components/incubator/income/TableNotRelate.js